module.exports = __webpack_public_path__ + "static/img/icon-excel.c8b1bb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report-imgs/icon-excel.png
// module id = sluv
// module chunks = 3